import AppComponent from '../../mixins/app-component'

export default
{
    name: 'app-icon',

    mixins: [
        AppComponent
    ],

    props: {
        name: { type: String, default: '' },
        scale: { type: null, default: 1 },
        width: { type: null, default: null },
        height: { type: null, default: null }
    },

    computed: {
        isSVG() {
            if (this.name.includes('.png') || this.name.includes('.jpg') || this.name.includes('.jpeg')) {
                return false
            }

            return true
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-icon/script.js